import {CreateTreeNode} from "../view-model";

export const findNodeByCaId = <T extends CreateTreeNode<T>>(
  node: T,
  caId: string
): T | undefined => {
  if (node.caId === caId) {
    return node;
  }
  for (const child of node.children) {
    const match = findNodeByCaId(child, caId);
    if (match) {
      return match;
    }
  }
  return undefined;
};
